function isNull(obj)
{
  return obj === null;
}

document.addEventListener("click", function(e)
{
  var target = e.target;

  while(target && (!target.classList || !target.classList.contains("js-multiproduct-toggle")))
    target = target.parentNode;

  if(isNull(target))
    return;

  target.classList.toggle("js-active");
  target.firstElementChild.querySelector('.js-multiproduct-label-short').classList.toggle('k-d-none');
  target.firstElementChild.querySelector('.js-multiproduct-label-long').classList.toggle('k-d-none');
  target.firstElementChild.lastElementChild.classList.toggle('js-active');
  target.nextElementSibling.classList.toggle('k-d-none');
});

window.addEventListener('scroll', function()
{
  const multiproductStickyEls = document.querySelectorAll('.js-multiproduct-sticky');

  [...multiproductStickyEls].forEach((item) =>
  {
    const { top } = item.getBoundingClientRect();

    if (!item.classList.contains('js-active') && top <= 0)
    {
      item.classList.add('js-active');
      item.setAttribute('animating', '1');
      setTimeout(() =>
      {
        item.setAttribute('animating', '0');
      }, 500);
    }
    else if (item.classList.contains('js-active') && top >= 100 && item.getAttribute('animating') === '0')
      item.classList.remove('js-active');
  });
}, false);
